module.exports = __webpack_public_path__ + "img/icon_nfc.c8dbdb9e.png";